import { FIELDS_OF_LAW_ENDPOINT } from 'common/constants'
import { request } from 'common/utils'
import { FieldOfLawInput } from 'packages-mui/advice/interfaces'

import query from '../graphql/createFieldOfLaw.graphql'
import { CreateFieldOfLawMutation } from '../interfaces/schemaDefinition'

export const createFieldOfLaw = (fieldOfLaw: FieldOfLawInput): Promise<CreateFieldOfLawMutation> =>
  request<CreateFieldOfLawMutation>(FIELDS_OF_LAW_ENDPOINT, query, { fieldOfLaw })
